import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { bmxurl } from 'src/globals';
import { tillproductoptions } from 'src/types/tillproductoptions';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../../_services/global.service';

@Component({
  selector: 'app-tillproductoptions',
  templateUrl: './tillproductoptions.component.html',
  styleUrls: ['./tillproductoptions.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TillproductoptionsComponent implements OnInit {
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  httpResponse: any;
  ListOptions: tillproductoptions[] = [];
  selectedItems: any;
  isDisabled: boolean = true;
  pageReady: boolean = false;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;

  constructor(
    private http: HttpClient,
    private router: Router,
    private messageService: MessageService,
    private globalService: GlobalService
  ) {}

  ngOnInit(): void {
    this.globalService.setSmallScreenMenu(false);

    const userid = localStorage.getItem("SmartUserID");
    this.http.get(bmxurl + "User/" + userid).subscribe({
      next: (response: any) => {
        this.httpResponse = response as users_returndata;
        if (this.httpResponse.succeeded) {
          this.AccessAllowed = true;
          this.loadgrid(false);
        }
        this.CompletedLoading = true;
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while getting User' });
      }
    });
  }

  loadgrid(showDisabled: boolean): void {
    this.http.get(bmxurl + "TillProductOptionsList/" + this.VenueID + "/" + showDisabled).subscribe({
      next: (response: any) => {
        this.httpResponse = response;
        if (this.httpResponse.succeeded) {
          this.ListOptions = this.httpResponse.data ?? [];
          this.pageReady = true;
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error getting Product Options: ' + (this.httpResponse.messages?.[0] ?? '') });
        }
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error getting Product Options' });
      }
    });
  }

  toggleDisabled(): void {
    this.loadgrid(!this.isDisabled);
  }

  editData(id: string): void {
    this.router.navigateByUrl("/tillproductoptionsedit/" + id);
  }

  disableData(id: string): void {
    this.http.delete(bmxurl + "TillProductOption/" + this.VenueID + "/" + id).subscribe({
      next: (response: any) => {
        this.httpResponse = response;
        if (this.httpResponse.succeeded) {
          this.messageService.add({ severity: 'success', summary: 'Disabled', detail: 'Option successfully disabled' });
          this.loadgrid(false);
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error disabling option' });
        }
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error disabling option' });
      }
    });
  }

  disableMulti(): void {
    if (!this.selectedItems?.length) return;
    this.selectedItems.forEach((item: tillproductoptions) => {
      this.disableData(item.id);
    });
  }
}
